<template>
  <div class="wrapper">
    <div class="main">
      <div class="section">
        <div class="container">
          <md-card class="bar-breadcrumb">
            <md-card-content>
              <div class="md-layout">
                <div class="md-layout-item">
                  <router-link to="/">{{ $t("主页") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <router-link to="/orders">{{ $t("訂單") }}</router-link>
                  <span class="breadcrumb-slash">/</span>
                  <span>{{ $t("詳情") }}</span>
                </div>
              </div>
            </md-card-content>
          </md-card>

          <md-card>
            <div class="container">
              <div class="md-title title-category">{{ $t("收件人资料") }}</div>
            </div>

            <md-card-content>
              <form novalidate class="md-layout" @submit.prevent="validateUser">
                <div class="md-layout-item">
                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.name">
                        <label for="name">{{ $t("姓名") }}</label>
                        <md-input
                          disabled
                          name="name"
                          id="name"
                          v-model="order.name"
                          @focus="clearError('name')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.email">
                        <label for="email">{{ $t("电邮") }}</label>
                        <md-input
                        disabled
                          name="email"
                          id="email"
                          v-model="order.email"
                          @focus="clearError('email')"
                        />
                      </md-field>
                    </div>

                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.phone">
                        <label for="phone">{{ $t("电话") }}</label>
                        <md-input
                        disabled
                          name="phone"
                          id="phone"
                          v-model="order.phone"
                          @focus="clearError('phone')"
                        />
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.state">
                        <label for="state">{{ $t("省") }}</label>
                        <md-select
                        disabled
                          name="state"
                          id="state"
                          v-model="order.state"
                          @focus="clearError('state')"
                        >
                          <md-option
                            v-for="(state_option, si) in state_options"
                            :key="si"
                            :value="state_option"
                          >{{state_option}}</md-option>
                        </md-select>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-small-size-100"
                      v-if="(order.state && order.state != '香港特别行政区')"
                    >
                      <md-field :class="order_error.city">
                        <label for="city">{{ $t("市") }}</label>
                        <md-select
                        disabled
                          name="city"
                          id="city"
                          v-model="order.city"
                          @focus="clearError('city')"
                        >
                          <md-option
                            v-for="(city_option, si) in city_options"
                            :key="si"
                            :value="city_option"
                          >{{city_option}}</md-option>
                        </md-select>
                      </md-field>
                    </div>

                    <div
                      class="md-layout-item md-small-size-100"
                      v-if="(order.state && order.state != '香港特别行政区')"
                    >
                      <md-field :class="order_error.address_1">
                        <label for="address_1">{{ $t("区") }}</label>
                        <md-select
                        disabled
                          name="address_1"
                          id="address_1"
                          v-model="order.address_1"
                          @focus="clearError('address_1')"
                        >
                          <md-option
                            v-for="(district_option, si) in district_options"
                            :key="si"
                            :value="district_option"
                          >{{district_option}}</md-option>
                        </md-select>
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.address_2">
                        <label for="address_2">{{ $t("详细地址") }}</label>
                        <md-textarea
                        disabled
                          name="address_2"
                          id="address_2"
                          md-autogrow
                          v-model="order.address_2"
                          @focus="clearError('address_2')"
                        ></md-textarea>
                      </md-field>
                    </div>
                  </div>

                  <div class="md-layout md-gutter" v-if="(order.state && order.state != '香港特别行政区')">
                    <div class="md-layout-item md-small-size-100">
                      <md-field :class="order_error.china_id">
                        <label for="china_id">{{ $t("身份证明号码") }}</label>
                        <md-input
                        disabled
                          name="china_id"
                          id="china_id"
                          v-model="order.china_id"
                          @focus="clearError('china_id')"
                        />
                      </md-field>
                    </div>
                  </div>
                </div>
              </form>
            </md-card-content>
          </md-card>

          <md-card>
            <div class="container">
              <div class="md-title title-category">{{ $t("订单详情") }}</div>
            </div>

            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head>{{ $t("产品") }}</md-table-head>
                  <md-table-head md-numeric>{{ $t("价钱") }}</md-table-head>
                  <md-table-head md-numeric>{{ $t("数量") }}</md-table-head>
                  <md-table-head md-numeric>{{ $t("小计") }}</md-table-head>
                </md-table-row>

                <md-table-row v-for="(product, product_key) in display_products" :key="product_key">
                  <md-table-cell>{{product.name_cn}}</md-table-cell>
                  <md-table-cell md-numeric>${{product.price}}</md-table-cell>
                  <md-table-cell md-numeric>
                    <div class="container-numeric">{{product.quantity}}</div>
                  </md-table-cell>
                  <md-table-cell md-numeric>
                    <div class="container-numeric">
                      <div>${{product.sub_total}}</div>
                    </div>
                  </md-table-cell>
                </md-table-row>

                <md-table-row v-if="order.discount_amount && order.discount_amount > 0">
                  <md-table-cell colspan="3" md-numeric>{{ $t("折扣") }}</md-table-cell>
                  <md-table-cell>
                    <div class="container-numeric">${{order.discount_amount}}</div>
                  </md-table-cell>
                </md-table-row>

                <md-table-row>
                  <md-table-cell colspan="3" md-numeric>{{ $t("总额") }}</md-table-cell>
                  <md-table-cell>
                    <div class="container-numeric">${{order.payment_amount}}</div>
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>

    <md-dialog-alert
      :md-active.sync="show_payment_qr"
      md-title="微信支付"
      :md-content="payment_qr_message"
      md-confirm-text="確定"
    />
  </div>
</template>

<script>
export default {
  components: {},
  name: "checkout",
  bodyClass: "checkout-page",
  props: {},
  data() {
    return {
      state_options: [
        "香港特别行政区",
        "台湾省",
        "新疆维吾尔自治区",
        "云南省",
        "河南省",
        "贵州省",
        "海南省",
        "澳门特别行政区",
        "黑龙江省",
        "江西省",
        "内蒙古自治区",
        "四川省",
        "湖南省",
        "安徽省",
        "天津市",
        "天津市",
        "北京市",
        "山东省",
        "湖北省",
        "吉林省",
        "上海市",
        "江苏省",
        "西藏自治区",
        "辽宁省",
        "山西省",
        "河北省",
        "浙江省",
        "甘肃省",
        "重庆市",
        "福建省",
        "广西壮族自治区",
        "青海省",
        "广东省",
        "宁夏回族自治区"
      ],

      city_options: [
        "阿克苏地区",
        "保山市",
        "安阳市",
        "安顺市",
        "白沙黎族自治县",
        "澳门",
        "大庆市",
        "抚州市",
        "阿拉善盟",
        "长沙市",
        "安徽省",
        "天津市",
        "安康市",
        "北京市",
        "滨州市",
        "鄂州市",
        "白城市",
        "上海市",
        "常州市",
        "阿里地区",
        "鞍山市",
        "长治市",
        "香港",
        "保定市",
        "杭州市",
        "白银市",
        "重庆市",
        "福建省",
        "百色市",
        "果洛藏族自治州",
        "潮州市",
        "固原市"
      ],

      district_options: [
        "高淳区",
        "鼓楼区",
        "建邺区",
        "江宁区",
        "溧水区",
        "六合区",
        "南京市",
        "浦口区",
        "栖霞区",
        "秦淮区",
        "玄武区",
        "雨花台区",
        "姑苏区",
        "虎丘区",
        "昆山市",
        "苏州市",
        "太仓市",
        "吴江区",
        "吴中区",
        "相城区"
      ],

      show_payment_qr: false,
      payment_qr_message: "",
      order: {
        name: "",
        phone: "",
        email: "",
        state: "",
        city: "",
        address_1: "",
        address_2: "",
        china_id: ""
      },
      order_error: {
        name: "",
        phone: "",
        email: "",
        state: "",
        city: "",
        address_1: "",
        address_2: "",
        china_id: ""
      },
      products: [{}, {}, {}, {}],
      braintree_instance: false,
      txt_discount_code : '',
      discount_rate : false
    };
  },
  methods: {
    async getOrder() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.$conf.API_HOST}`,
        url: "wx_order_detail_get.php",
        data: {
          member_id: this.$store.state.member_id,
          order_id: this.$route.params.id,
        }
      });

      this.products = response.data.products;
      if(response.data.discount_code){
        this.txt_discount_code = response.data.discount_code.discount_code;
        this.discount_rate = parseFloat(response.data.discount_code.discount_rate);
      }else{
        this.txt_discount_code = '';
        this.discount_rate = false;
      }

      this.order = response.data.order;

      this.loader.hide();
    },
  },
  computed: {
    total_amount() {
      let total_amount = 0;
      for (let i in this.products) {
        let product = this.products[i];
        total_amount +=
          parseFloat(product.price) * parseFloat(product.quantity);
      }
      let discount_amount = 0;
      if(this.discount_rate){
        discount_amount = total_amount * this.discount_rate
      }
      total_amount = total_amount - discount_amount;
      total_amount = this.$numeral(total_amount).format("0,0.0");

      return total_amount;
    },

    discount_amount() {
      if(!this.discount_rate){
        return 0;
      }
      let total_amount = 0;
      for (let i in this.products) {
        let product = this.products[i];
        total_amount +=
          parseFloat(product.price) * parseFloat(product.quantity);
      }
      let discount_amount = total_amount * this.discount_rate;
      discount_amount = this.$numeral(discount_amount).format("0,0.0");

      return discount_amount;
    },
    display_products() {
      return this.products.map(p => {
        p.sub_total = parseFloat(p.price) * parseFloat(p.quantity);
        p.price = this.$numeral(p.price).format("0,0.0");
        p.sub_total = this.$numeral(p.sub_total).format("0,0.0");
        return p;
      });
    },
  },
  async created() {
    await this.getOrder();
  },
  async mounted() {
    this.loader = this.$loading.show({
      isFullPage: true,
      canCancel: false
    });
  },
  beforeDestroy() {}
};
</script>
<style lang="scss">
.img-product {
  height: 150px;
}

.container-checkout_btn {
  display: flex;
  justify-content: flex-end;
}
</style>